export function csvEscape(value) {
  const s = String(value ?? '');
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * Build a CyberTracer export filename bound to the active search target.
 * Same pattern for PDF and Debug JSON: ``CyberTracer-{module}-{target}.{ext}``.
 *
 * @param {object} opts
 * @param {string} [opts.moduleName]
 * @param {string} [opts.target]
 * @param {string} [opts.extension='pdf'] Extension without leading dot.
 * @returns {string}
 */
export function buildCyberTracerExportFilename({
  moduleName = '',
  target = '',
  extension = 'pdf',
} = {}) {
  const safeModule =
    String(moduleName || '')
      .replace(/[^a-z0-9-_]+/gi, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 40) || 'report';
  const safeTarget =
    String(target || '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9@+._-]+/gi, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 80) || 'target';
  const ext = String(extension || 'pdf')
    .replace(/^\./, '')
    .replace(/[^a-z0-9]+/gi, '')
    .toLowerCase() || 'pdf';
  return `CyberTracer-${safeModule}-${safeTarget}.${ext}`;
}

export function triggerDownload(filename, content, mimeType = 'text/plain;charset=utf-8') {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
